<!-- 代管配置 -->
<template>
  <div class="delegate-setting">
    <div class="title">{{ t('route.delegate') }}</div>
    <div class="content">
      <div class="form-area">
        <custom-form
          ref="refForm"
          :loading="loading"
          :formData="formData"
          :formRules="formRules"
          @submitForm="submitForm" />
        <div class="save_mfa">
          <el-button type="primary" :disabled="loading" :loading="submitLoading" @click="submit">{{ t('form.submit') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { reactive, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { updateSysConfig, addSysConfig, getSysConfig } from '@/api/noticeSetting'
import { ElMessage } from 'element-plus'
import checkRules from '@/components/CustomCheck'

const { t } = useI18n()
const refForm = ref()
const submitLoading = ref(false)
const loading = ref(false)
const configData = ref({}) // 配置数据-用来判断是否是第一次配置
const settingName = 'impersonation'

// 规则校验
const { urlCheck } = checkRules(t)
const formRules = reactive({
  dr_addr: urlCheck,
  migration_addr: urlCheck
})

// 表单数据
const formData = reactive({
  dr_addr: { // 容灾平台地址
    type: 'input',
    label: t('user.delegate_dr_label'),
    prop: 'dr_addr',
    tip: t('user.delegate_dr_tip')
  },
  migration_addr: { // 迁移平台地址
    type: 'input',
    label: t('user.delegate_migration_label'),
    prop: 'migration_addr',
    tip: t('user.delegate_migration_tip')
  }
})

// 获取上次配置
const getDelegateConfig = async() => {
  loading.value = true
  try {
    const res = await getSysConfig({ name: settingName, display_name: settingName })
    configData.value = res.data.metadata || {}
    formData.dr_addr.value = configData.value.dr_addr || ''
    formData.migration_addr.value = configData.value.migration_addr || ''
    loading.value = false
  } catch (error) {
    loading.value = false
  }
}

// 确定
const submit = () => refForm.value.submit()
// 表单提交
const submitForm = (form) => {
  form.validate(async valid => {
    if (!valid) return
    const isAdd = !Object.keys(configData.value).length
    let formVal = {
      name: settingName,
      display_name: settingName,
      status: 'enabled'
    }
    if (isAdd) {
      formVal = {
        ...formVal,
        metadata: {
          dr_addr: formData.dr_addr.value,
          migration_addr: formData.migration_addr.value
        }
      }
    } else {
      delete formVal.status
      formVal = {
        ...formVal,
        update_data: {
          status: 'enabled',
          metadata: {
            dr_addr: formData.dr_addr.value,
            migration_addr: formData.migration_addr.value
          }
        }
      }
    }
    submitLoading.value = true
    try {
      const api = isAdd ? addSysConfig : updateSysConfig
      const res = await api(formVal)
      if (res.code === '00000000') {
        ElMessage.success(`${t('table.success')}`)
      }
      submitLoading.value = false
    } catch (error) {
      submitLoading.value = false
    }
  })
}
onMounted(() => {
  getDelegateConfig()
})
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.delegate-setting {
  ::v-deep(.el-form-item__label) {
    width: 185px !important;
  }
  ::v-deep(.el-form-item__content) {
    width: calc(100% - 185px) !important;
  }
  ::v-deep(.el-form-tip) {
    margin-left: 185px !important;
  }
  .title {
    margin-bottom: 16px;
    font-size: 14px;
    color: $grey-9;
  }
  .form-area {
    width: 620px;
    margin: 0 auto;
    .save_mfa {
      margin-top: 16px;
      width: 100%;
      text-align: right;
    }
    :deep(.el-form-item__error) {
      margin-top: 16px !important;
    }
  }
}
</style>